import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { FiSearch } from 'react-icons/fi';

export default function AdminUsers() {
  const [data, setData] = useState<any>(null);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  const load = (p = 1, q = '') => {
    api.get(`/admin/users?page=${p}&search=${q}`).then((res) => setData(res.data));
  };

  useEffect(() => { load(); }, []);

  const handleSearch = () => { setPage(1); load(1, search); };

  if (!data) return <div className="empty-state"><p>Loading...</p></div>;

  return (
    <div>
      <h1 style={{ margin: '0 0 20px', fontSize: 22, fontWeight: 700 }}>Users</h1>

      <div className="admin-search">
        <input
          placeholder="Search by name or email..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
        />
        <button className="btn btn-primary" onClick={handleSearch}><FiSearch /></button>
      </div>

      <div className="card">
        <div className="data-table">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Stores</th>
                <th>Joined</th>
              </tr>
            </thead>
            <tbody>
              {data.data.map((user: any) => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td><strong>{user.first_name} {user.last_name}</strong></td>
                  <td>{user.email}</td>
                  <td>
                    <span style={{
                      padding: '2px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600,
                      background: user.role === 'admin' ? '#ef444418' : '#3b82f618',
                      color: user.role === 'admin' ? '#ef4444' : '#3b82f6',
                    }}>
                      {user.role}
                    </span>
                  </td>
                  <td>
                    {user.stores?.map((s: any) => (
                      <div key={s.id} style={{ fontSize: 12, marginBottom: 2 }}>
                        <strong>{s.name}</strong>
                        <span style={{ color: 'var(--gray-400)', marginInlineStart: 4 }}>
                          ({s.products_count} products, {s.orders_count} orders)
                        </span>
                      </div>
                    ))}
                    {(!user.stores || user.stores.length === 0) && <span style={{ color: 'var(--gray-400)' }}>-</span>}
                  </td>
                  <td style={{ fontSize: 13 }}>{new Date(user.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {data.last_page > 1 && (
        <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'center' }}>
          {Array.from({ length: data.last_page }, (_, i) => i + 1).map((p) => (
            <button
              key={p}
              className={`btn ${p === data.current_page ? 'btn-primary' : 'btn-outline'}`}
              style={{ minWidth: 36, padding: '6px 10px', fontSize: 13 }}
              onClick={() => { setPage(p); load(p, search); }}
            >
              {p}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
